/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllScreenerSourcesRequest
 */
export interface FindAllScreenerSourcesRequest {
    /**
     * Include historical sources, ordered active first, merged second, and plainly deleted last, then newest creation time and ID first within each group.
     */
    include_deleted?: boolean;
    /**
     * 
     */
    source_id?: Array<string>;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    type?: Array<string>;
    /**
     * 
     */
    tag_id?: Array<string>;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
}

/**
 * Check if a given object implements the FindAllScreenerSourcesRequest interface.
 */
export function instanceOfFindAllScreenerSourcesRequest(value: object): value is FindAllScreenerSourcesRequest {
    return true;
}

export function FindAllScreenerSourcesRequestFromJSON(json: any): FindAllScreenerSourcesRequest {
    return FindAllScreenerSourcesRequestFromJSONTyped(json, false);
}

export function FindAllScreenerSourcesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerSourcesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'include_deleted': json['include_deleted'] == null ? undefined : json['include_deleted'],
        'source_id': json['source_id'] == null ? undefined : json['source_id'],
        'search': json['search'] == null ? undefined : json['search'],
        'type': json['type'] == null ? undefined : json['type'],
        'tag_id': json['tag_id'] == null ? undefined : json['tag_id'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'page': json['page'] == null ? undefined : json['page'],
    };
}

export function FindAllScreenerSourcesRequestToJSON(json: any): FindAllScreenerSourcesRequest {
    return FindAllScreenerSourcesRequestToJSONTyped(json, false);
}

export function FindAllScreenerSourcesRequestToJSONTyped(value?: FindAllScreenerSourcesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'include_deleted': value['include_deleted'],
        'source_id': value['source_id'],
        'search': value['search'],
        'type': value['type'],
        'tag_id': value['tag_id'],
        'limit': value['limit'],
        'page': value['page'],
    };
}

